import React, { useState, useRef, useEffect } from 'react';

const FeedbackIcon: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsMenuOpen(false);
      }
    };

    if (isMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  const handleIconClick = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleFeedbackClick = () => {
    window.open('https://tally.so/r/w2MV1e', '_blank', 'noopener,noreferrer');
    setIsMenuOpen(false);
  };

  const handleContactClick = () => {
    window.open('/contact', '_blank', 'noopener,noreferrer');
    setIsMenuOpen(false);
  };

  return (
    <div className="fixed bottom-6 right-6 z-50" ref={menuRef}>
      <div className="relative">
        {/* Menu options */}
        <div
          className={`absolute right-0 bottom-full mb-3 bg-white rounded-lg shadow-lg border transition-all duration-200 ${
            isMenuOpen ? 'opacity-100 visible transform translate-y-0' : 'opacity-0 invisible transform translate-y-2'
          }`}
        >
          <div className="py-2 min-w-[140px]">
            <button
              onClick={handleFeedbackClick}
              className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 transition-colors duration-150 text-sm"
            >
              Send Feedback
            </button>
            <button
              onClick={handleContactClick}
              className="w-full px-4 py-2 text-left text-gray-700 hover:bg-gray-100 transition-colors duration-150 text-sm"
            >
              Contact Us
            </button>
          </div>
        </div>



        {/* Telegram-style icon button */}
        <button
          onClick={handleIconClick}
          className="w-10 h-10 bg-black hover:bg-gray-800 rounded-full shadow-lg hover:shadow-xl transition-all duration-200 flex items-center justify-center group"
          aria-label="Send Feedback"
        >
          {/* Telegram paper plane icon */}
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="text-white transform group-hover:scale-110 transition-transform duration-200"
          >
            <path
              d="M2.01 21L23 12L2.01 3L2 10L17 12L2 14L2.01 21Z"
              fill="currentColor"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default FeedbackIcon;